<template>
    <draggable id="jobstatuscontainer" v-model="reports_statusevents.reportChecks" :disabled="!showConfig || !!reports_statusevents.reportConfig.includeallchecks" direction="vertical" @change="reorder($event)">
        <div v-for="job in reports_statusevents.reportChecks" v-bind:key="(job.key || job._id)">
            <ReportCheckStatusCheck :jobprop="job" :showConfig="showConfig" :availablemetrics="availablemetrics" v-if="showme(job)" />
        </div>
    </draggable>

</template>

<script>
import appconfig from "../config/shared";
import { mapState } from "vuex";
import { format as date_format, parse as date_parse, subDays } from "date-fns";
import { formatDay } from "../lib/filter";
import draggable from 'vuedraggable';
import ReportCheckStatusCheck from "./Reports_Statusevents_Checkstatus_Check";

export default {
    name: "Reports_Statusevents_Checkstatus",
    props: {
        showConfig: {
            type: Boolean,
            default: false
        },
        availablemetrics: {
            type: Array
        }
    },
    components: { draggable, ReportCheckStatusCheck },
    data () {
        return {
            showCheckConfig: false,
            confirmRemoveCheck: false,
            showJobJSON: false,
            customCheckSettings: {}
        };
    },
    computed: {
        ...mapState(["currentUser", "checks", "reports_statusevents", "now"])
    },
    methods: {
        showme: function (job) {
            if(
                (this.reports_statusevents.reportConfig.hideupchecks && job.status === 'up') ||
                (this.reports_statusevents.reportConfig.hidedisabledchecks && job.status === 'inactive') ||
                (this.reports_statusevents.reportConfig.hidedownchecks && job.status === 'down')
            ){
                // console.log('hiding', job._id, job.status, this.reports_statusevents.reportConfig.hideupchecks, this.reports_statusevents.reportConfig.hidedisabledchecks, this.reports_statusevents.reportConfig.hidedownchecks )
                return false;
            } else {
                return true;
            }
        },
        reorder: function (val) {
            val.moved.checkid = val.moved.element._id;
            delete val.moved.element;
            // console.log('reorder', val, this.reports_statusevents.reportChecks.map( (o, idx) => { return { checkid: o._id, old: o.report.order, idx: idx, job: o.report } } ));
            this.$store.dispatch('reports_statusevents/setCheckReorder', val);
        }

    }
};
</script>


